module.exports = __webpack_public_path__ + "img/portfolio-08.f8f1b37f.jpg";